import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Spinner } from '../common';
import { cambiarStringApp, getArticuloEnAPI, getArticulosEnAPI, unsetArticulo } from '../../actions';
import TextoTransform from '../../util/TextoTransform';
import ModalError from '../common/ModalError';
import history from '../../history';

class Articulo extends Component {
  constructor(props) {
    super(props);

    this.jump1 = React.createRef();
    this.jump2 = React.createRef();
  }

  componentDidMount() {
    this.props.cambiarStringApp('cabecera_titulo', 'cabecerasTitulos.portada');
    this.props.cambiarStringApp('cabecera_titulo_s', 'cabecerasTitulos.portada_s');
    this.props.cambiarStringApp('cabecera_titulo_xs', 'cabecerasTitulos.portada_xs');
    this.props.cambiarStringApp('cabecera_subtitulo', 'cabecerasSubtitulos.portada');
    this.props.cambiarStringApp('sr_only', 'sr_only.portada');

    if (this.props.match.params.idioma !== 'es') { history.replace(`/${this.props.idioma}/${this.props.match.params.articulo_slug}`); }
    this.props.getArticuloEnAPI(this.props.match.params.articulo_slug);
  }

  componentDidUpdate() {
    if (this.props.spinner_app === true) { setTimeout(() => { window.scrollTo(0, 0); }, 100); }

    if (this.props.match.params.articulo_slug !== this.props.articulo_slug && this.props.spinner_app === false && this.props.articulo_slug !== '' && this.props.error_app === '' && this.props.mostrar_error_app === false) {
      this.props.getArticuloEnAPI(this.props.match.params.articulo_slug);
    }
  }

  componentWillUnmount() {
    this.props.unsetArticulo();
  }

  handleClickEtiquetas = etiqueta => {
    this.props.cambiarStringApp('articulos_filtros', [etiqueta.currentTarget.textContent]);

    this.props.getArticulosEnAPI(0, this.props.articulos_limit, [etiqueta.currentTarget.textContent], [], true); // El último true es para que haga el salto del scroll

    // Marco un estado para que no vuelva a hacer la consulta a la API la Portada en su componentDidMount, que entre otras cosas los filtros los tiene como []
    this.props.cambiarStringApp('viene_de_articulo', true);

    history.push(`/${this.props.match.params.idioma}/`);
  }

  handleClickJump = jump => {
    if (jump.currentTarget.id === 'jump1') {
      this.jump1.current.scrollIntoView({ behavior: 'smooth' });
    } else if (jump.currentTarget.id === 'jump2') {
      this.jump2.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  renderArticulo() {
    if (this.props.spinner_app === true) { return <Spinner />; }

    if (this.props.articulo_titulo === '') { return null; }

    const etiquetado = [];
    this.props.articulo_etiquetas.sort().forEach((etiqueta, key) => {
      const etiq = (<p className="etiquetas" key={key} onClick={this.handleClickEtiquetas}>{etiqueta}</p>);
      etiquetado.push(etiq);
    });

    // const date = new Date(this.props.articulo_fecha);

    return (
      <article className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12">
        <header>
          <h2 className="fontBold fontBig textoAzul margenInferiorMed">Artículo creado por {this.props.articulo_nombre} | LinkedIn <a className="linkAzulAzulClaro" href={`https://www.linkedin.com/in/${this.props.articulo_linkedin}`}>@{this.props.articulo_linkedin}</a></h2>
          {/*   <p className="fontBig">Fecha del artículo {date.toLocaleDateString()}</p>            DESCOMENTAR PARA SACAR LAS FECHAS                 */ }
          <p className="textoEtiquetas margenDerechaMinMed">Etiquetado en</p>
          {etiquetado}
        </header>
        <hr className="cabecera margenInferiorBig" />
        { /* contenido */ }
        <TextoTransform contenido={this.props.articulo_contenido} />
      </article>
    );
  }

  renderHelmet() {
    const resumen = this.props.articulo_resumen.replace(':-:br:-:', ' ');

    return (
      <Helmet>
        <title>{this.props.articulo_titulo} | Antarie</title>
        <meta content={resumen} name="description" />
        <meta content="software, paginas, web, apps, aplicaciones, ios, android, inteligencia, artificial. machine, learning, react, native, express, python, symfony, mongo, node, linux, mysql, docker, cloud, nube" name="Keywords" />
      </Helmet>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <ModalError texto={this.props.error_app} textoCancelar={t('common:modalError.cerrar')} visible={this.props.mostrar_error_app} />

        {this.renderHelmet()}

        <section className="contenedor maxWidth margenInferiorBig">
          <header className="cajeadoHorizontal margenInferiorBigMedBig">
            <h2 className="hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs textoAzul fontBold fontH1 textoCentrado">{this.props.articulo_titulo}</h2>
            <h2 className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-s hidden-xs hidden-xxs textoAzul fontBold fontH1 textoCentrado">{this.props.articulo_titulo}</h2>
            <h2 className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m textoAzul fontBold fontH1 textoCentrado">{this.props.articulo_titulo}</h2>
            <hr className="separacion" />
          </header>

          <div className="contenedor">
            <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-2 col-pxs-2 col-pxxs-3 col-xxl-2 col-xl-2 col-l-2 hidden-m hidden-s hidden-xs hidden-xxs">
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Animaciones</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Docker</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Firewall</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Hooks</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Programación</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>React</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Seguridad</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Sistemas</p>
            </div>

            <div className="col-pxxxl-40 col-pxxl-22 col-pxl-14 col-pl-16 col-pm-14 col-ps-13 col-pxs-14 col-pxxs-13 col-xxl-10 col-xl-10 col-l-10 col-m-12 col-s-12 col-xs-12 col-xxs-12 cajeadoHorizontal">
              {this.renderArticulo()}
            </div>

            <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-1 hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { idioma, articulos_limit, articulo_titulo, articulo_nombre, articulo_linkedin, articulo_slug, articulo_fecha, articulo_etiquetas, articulo_contenido, articulo_resumen, error_app, mostrar_error_app, spinner_app } = app;

  return { idioma, articulos_limit, articulo_titulo, articulo_nombre, articulo_linkedin, articulo_slug, articulo_fecha, articulo_etiquetas, articulo_contenido, articulo_resumen, error_app, mostrar_error_app, spinner_app };
};

export default compose(
  connect(mapStateToProps, { cambiarStringApp, getArticuloEnAPI, getArticulosEnAPI, unsetArticulo }),
  withTranslation('blog')
)(Articulo);
